import React, { useState } from 'react';
import styled from 'styled-components';
import MenuItem from './components/MenuItem';
import { theme } from '../../styled';
import { ChevronDown, ChevronUp } from '../Icons';
export const Styled = styled.div `
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;

  background: #fff;
  height: 32px;
  z-index: 20;

  &.open {
    height: auto;

    .footer-content {
      padding-top: 6px;
      padding-bottom: 6px;
      flex-direction: column;
    }

    .copyright {
      display: flex;
    }
  }
`;
export const ContainerWrapper = styled.div `
  display: flex;
  max-width: ${(props) => props.containerFullWidth ? '100%' : props.theme.containerMaxWidth};
  margin: 0 auto;
  justify-content: space-between;
  width: 100%;
  height: 100%;
  align-items: center;
  padding-right: 27px;

  @media ${(props) => props.theme.md} {
    padding-right: 0;
    margin: ${(props) => (props.containerFullWidth ? '0 15px' : '0 auto')};
  }
`;
export const MenuSection = styled.ul `
  display: flex;
  height: 100%;
  margin: 0;
  padding: 0;
`;
export const Copyright = styled.div `
  font-size: ${(props) => props.theme.fontXXSmall};
  line-height: 18px;
  color: ${(props) => props.theme.darkGray};
  padding-right: 16px;
  display: none;

  @media ${theme.md} {
    display: inline-flex;
  }
`;
export const Captcha = styled.div `
  font-size: ${(props) => props.theme.fontXXSmall};
  line-height: 18px;
  color: ${(props) => props.theme.darkGray};
  padding-right: 16px;
  display: none;
  a {
    color: ${(props) => props.theme.blue};
  }

  @media ${theme.md} {
    display: inline-flex;
  }
`;
export const IconWrapper = styled.div `
  display: flex;
  background-color: #fff;
  height: 100%;
  position: absolute;
  right: 16px;
  top: 10px;

  @media ${theme.md} {
    display: none;
  }
`;
const Footer = ({ menu, rightText, containerFullWidth, googleCaptcha, }) => {
    const [open, setToggle] = useState(false);
    return (React.createElement(Styled, { className: `Footer ${open ? 'open' : ''}` },
        React.createElement(ContainerWrapper, { containerFullWidth: containerFullWidth, className: "footer-content" },
            React.createElement(MenuSection, null, menu.map((item) => (React.createElement(MenuItem, { key: item.id, item: item })))),
            React.createElement("div", null,
                googleCaptcha && (React.createElement(Captcha, { className: "captcha" }, googleCaptcha)),
                React.createElement(Copyright, { className: "copyright" }, rightText)),
            React.createElement(IconWrapper, { className: "footer-arrow", onClick: () => setToggle(!open) }, !open ? React.createElement(ChevronUp, null) : React.createElement(ChevronDown, null)))));
};
Footer.defaultProps = {
    containerFullWidth: false,
};
export default Footer;
